import { checkauth } from '../Helper';

const Redirects = () => import('../views/redirects/Index.vue');
const RedirectCreate = () => import('../views/redirects/Create.vue');
const RedirectEdit = () => import('../views/redirects/Edit.vue');

const guard = (to, from, next) => {
	checkauth().then(response => (response ? next() : next('/login')));
};

export default [
	{ path: '/ecommerce/redirects', name: 'redirects', component: Redirects, beforeEnter: guard },
	{ path: '/ecommerce/redirects/new', name: 'redirects-new', component: RedirectCreate, beforeEnter: guard },
	{ path: '/ecommerce/redirects/:id([0-9a-fA-F]{24})', name: 'redirects-edit', component: RedirectEdit, beforeEnter: guard },
];
